export default "__VITE_ASSET__ae0s2sZT__"